import { useEffect } from 'react';

const useScrollbarCompensation = (
  ref: React.RefObject<HTMLElement>,
  paddingX: number
): void => {
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const update = () => {
      const scrollbarWidth = el.offsetWidth - el.clientWidth;
      el.style.paddingLeft = `${paddingX}px`;
      el.style.paddingRight = `${Math.max(0, paddingX - scrollbarWidth)}px`;
    };

    const observer = new ResizeObserver(update);
    observer.observe(el);
    update();

    return () => observer.disconnect();
  }, [ref, paddingX]);
};

export default useScrollbarCompensation;
